import { transformConstants } from '../helpers';

const ingredientLibraryConstants = transformConstants([
  'MOKAPOS_INGREDIENT_LIBRARY_SELECT',
  'MOKAPOS_INGREDIENT_LIBRARY_CREATE_ALL_OUTLET',
  'MOKAPOS_INGREDIENT_LIBRARY_CREATE_ONE_OUTLET',
  'MOKAPOS_INGREDIENT_LIBRARY_DELETE',
  'MOKAPOS_INGREDIENT_LIBRARY_COGS_TRACKING_START',
  'MOKAPOS_INGREDIENT_LIBRARY_COGS_TRACKING_MANAGE',
  'MOKAPOS_INGREDIENT_LIBRARY_CREATE_SFI_COUNT',
]);

export { ingredientLibraryConstants };
